import React from 'react';
import styled from 'styled-components';

import { fromDateTime } from '@/services/ws-digital/src/main/resources/rest-api';
import type { SalesPromotionContactDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { Tooltip } from '@/js/libs/ui';

import { DATE_TIME_FORMAT } from 'src/constants';
import { MailStatus, getContactMailStatus, useTranslatedMailStatusLabels } from './helpers';

const NoDataWrapper = styled.span`
  color: ${({ theme }) => theme.colors.grey70_1};
`;

interface ContactMailStatusProps {
  contact: SalesPromotionContactDto;
}

export const ContactMailStatus: React.FC<ContactMailStatusProps> = React.memo(function ContactMailStatus({ contact }) {
  const mailStatus = getContactMailStatus(contact);
  const translatedMailStatusLabels = useTranslatedMailStatusLabels();

  if (mailStatus === MailStatus.Sent) {
    return (
      <Tooltip tooltip={contact.sentByUserName}>
        {`${translatedMailStatusLabels[mailStatus]}: ${fromDateTime(contact.mailingTime)?.local().format(DATE_TIME_FORMAT)}`}
      </Tooltip>
    );
  }

  if (mailStatus === MailStatus.None) {
    return <NoDataWrapper>{translatedMailStatusLabels[mailStatus]}</NoDataWrapper>;
  }
  return <>{translatedMailStatusLabels[mailStatus]}</>;
});
